export const hourlyRate = '$100/hour';

export const contactEmail = 'hello@cipherworks.ca';

export const location = 'Montreal, QC';

export const discoveryNote =
  'For complex or unusual projects, I offer a paid discovery phase (typically 5 to 10 hours) to scope the work and quote accurately.';
